import { gql } from '@provision/graphql-client';

const LEGAL_DOCUMENT_FIELDS = gql`
  fragment LegalDocumentFields on LegalDocumentView {
    legalDocumentId
    kind
    name
    title
    path
    bodyHtml
    createdAt
    updatedAt
    brandIds
  }
`;

export const GET_LEGAL_DOCUMENTS_QUERY = gql`
  query GetLegalDocuments($input: GetLegalDocumentsInput!) {
    getLegalDocuments(input: $input) {
      ...LegalDocumentFields
    }
  }
  ${LEGAL_DOCUMENT_FIELDS}
`;

export const SAVE_LEGAL_DOCUMENT_MUTATION = gql`
  mutation SaveLegalDocument($input: SaveLegalDocumentInput!) {
    saveLegalDocument(input: $input) {
      ...LegalDocumentFields
    }
  }
  ${LEGAL_DOCUMENT_FIELDS}
`;

export const ASSIGN_LEGAL_DOCUMENT_MUTATION = gql`
  mutation AssignLegalDocument($input: AssignLegalDocumentInput!) {
    assignLegalDocument(input: $input) {
      ...LegalDocumentFields
    }
  }
  ${LEGAL_DOCUMENT_FIELDS}
`;
